import React from 'react';
import classnames from 'classnames';
import InfoDialog from 'swag-client-common/components/info/info-dialog';
import confirmDialogClasses from 'swag-client-common/components/info/confirm-dialog/confirm-dialog.scss';
import { useTimeLeftForLimitedEdition } from 'swag-client-common/hooks/use-time-left-for-limited-edition';
import { Content } from './components/content';
import { TimeOverForLimitedEditionForm } from './components/time-over-for-limited-edition-form';
import { ConfirmSharedItemsChangesDialog } from './components/confirm-shared-items-changes-dialog/confirm-shared-items-changes-dialog';
import classes from './add-to-cart-warning-popup.scss';
const contentStyle = {
  width: '1000px',
  maxWidth: '1000px'
};
const TIME_OVER_FOR_LE_HEADER_TEXT = 'This product is no longer available!';
export function AddToCartWarningPopup({
  onClose,
  isOpenWarningPopup,
  headerText,
  isOpenConfirmSharedItemsChanges,
  onSharedItemsChangesConfirm,
  isLimitedEdition,
  expirationDateForLimitedEdition
}) {
  const timeLeftForLimitedEdition = useTimeLeftForLimitedEdition(expirationDateForLimitedEdition, isLimitedEdition);
  const isTimeOverForLimitedEdition = isLimitedEdition && timeLeftForLimitedEdition <= 0;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ConfirmSharedItemsChangesDialog, {
    isOpen: isOpenConfirmSharedItemsChanges,
    onCancel: onClose,
    onConfirm: onSharedItemsChangesConfirm
  }), /*#__PURE__*/React.createElement(InfoDialog, {
    dataPopup: "AddToCartWarning",
    content: isTimeOverForLimitedEdition ? /*#__PURE__*/React.createElement(TimeOverForLimitedEditionForm, null) : /*#__PURE__*/React.createElement(Content, null),
    onRequestClose: onClose,
    showCloseButton: true,
    open: isOpenWarningPopup,
    header: isTimeOverForLimitedEdition ? TIME_OVER_FOR_LE_HEADER_TEXT : headerText,
    titleClass: classnames(confirmDialogClasses.title, classes.title),
    headerless: false,
    bodyClassName: confirmDialogClasses.body,
    contentStyle: contentStyle,
    contentClassName: confirmDialogClasses.content,
    rootContentClassName: confirmDialogClasses.rootContent,
    contentWrapperClassName: confirmDialogClasses.contentWrapper,
    closeButtonClassName: isLimitedEdition ? confirmDialogClasses.orangeBackground : '',
    isResponsive: true
  }));
}